export default {"src":"/_next/static/media/logo-typo-fa.dd075279.svg","height":271,"width":803,"blurWidth":0,"blurHeight":0};